const normalizeOrderId = (value) => String(value ?? '').trim();

const normalizeStatus = (value) => String(value ?? '').trim().toUpperCase();

const unwrapPersistedOrder = (value) => {
    if (!value || typeof value !== 'object') return {};

    if (value.order && typeof value.order === 'object') return value.order;
    if (value.data && typeof value.data === 'object' && !Array.isArray(value.data)) return value.data;

    return value;
};

/**
 * Merge a cancellation result into the current order list.
 *
 * The requested status is authoritative because refund/status endpoints can
 * return the order snapshot from before the status write has been committed.
 */
export const mergeCancellationOrderState = (
    orders,
    targetOrder,
    persistedOrder,
    requestedStatus
) => {
    const targetId = normalizeOrderId(targetOrder?.primaryId);
    const persisted = unwrapPersistedOrder(persistedOrder);
    const authoritativeStatus = normalizeStatus(requestedStatus)
        || normalizeStatus(persisted.currentStatus || persisted.status);

    if (!targetId || !Array.isArray(orders)) return orders;

    return orders.map((order) => {
        if (normalizeOrderId(order?.primaryId) !== targetId) return order;

        return {
            ...order,
            ...persisted,
            ...(authoritativeStatus ? { currentStatus: authoritativeStatus } : {})
        };
    });
};

export { normalizeOrderId };
